import { useEffect, useState } from 'react';

import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { DynamicFormModal } from '@bringg-frontend/dynamic-form-modal';

import { TenderNotifyService } from '.';

interface Props {
	taskId: number;
	visible: boolean;
	onCancel: () => void;
}

const TenderNotifyModal = ({ taskId, visible, onCancel }: Props) => {
	const { t } = useTranslation();

	const [form, setForm] = useState(null);

	useEffect(() => {
		if (!TenderNotifyService.canShowForm(taskId)) {
			return;
		}

		setForm(TenderNotifyService.getForm(taskId));
	}, [taskId]);

	if (!form) {
		return null;
	}

	return (
		<DynamicFormModal
			title={t('TENDER_NOTIFY.FORM.TITLE')}
			okText={t('TENDER_NOTIFY.FORM.SUBMIT')}
			cancelText={t('TENDER_NOTIFY.FORM.CANCEL')}
			onClose={onCancel}
			destroyOnClose
			visible={visible}
			formFields={form}
			onSubmit={async values => TenderNotifyService.submitTenderNotify(taskId, values)}
			numberOfColumns={1}
		/>
	);
};

export default observer(TenderNotifyModal);
